import React from "react";
import { Navigate, Outlet } from "react-router";

export const ProtectedRoute = ({ redirectPath = '/' }) => {
    const sessionToken = localStorage.getItem('sessionToken');
 
    if (!sessionToken) {
        return <Navigate to={redirectPath} replace />;
    }

    return (
        <Outlet />
    )
}